import { PhotoIcon, UserCircleIcon } from "@heroicons/react/24/solid";
import { useEffect, useState } from "react";
import * as Icon from "react-bootstrap-icons";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
    SaveUserData,
    fetchUserData
  } from "../../redux/actions/settingActions";
import Toast from "../../components/assetLibComponents/shared/Toast";


export default function SettingProfile(props) {
    const dispatch = useDispatch();
    const fetchUser = useSelector(
        (state) => state.setting.fetchUserData
      );
    const [fName, setFName] = useState("")
    const [lName, setLName] = useState("")
    const [email, setEmail] = useState("")
    const [website, setWebsite] = useState("")
    const [companyName, setCompanyName] = useState("")
    const [mobile, setMobile] = useState("")

    useEffect(()=>{
        if(fetchUser){
            setFName(fetchUser?.first_name);
            setLName(fetchUser?.last_name);
            setEmail(fetchUser?.email);
            setWebsite(fetchUser?.domain);
            setCompanyName(fetchUser?.company_name);
            setMobile(fetchUser?.mobile);
        }
    },[fetchUser])

    useEffect(()=>{
        dispatch(fetchUserData(props.authToken));
    },[])
    
    const handleSubmit = () =>{
        const payload = {
            first_name:fName,
            last_name:lName,
            mobile:mobile,
            company_name:companyName,
        }
        if(fName == "" || lName == ""){
            Toast("Please Fill Required Fields", "E");

        }else{
            dispatch(SaveUserData(props.authToken,fName,lName,mobile,companyName));
        }
   } 


  return (
    <>
      <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
        <div className="text-lg leading-7 font-[500] my-auto">User Profile</div>
        <div className="flex items-center">
          <button
              onClick={handleSubmit}
            type="button"
            className="mr-4 inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] px-3 py-2 text-sm font-semibold text-white shadow-sm"
          >
            Save Changes
          </button>
        </div>
      </div>
      <div className="max-sm:h-full h-[73vh] listing">
      <form className="h-[73vh] max-sm:h-[80vh] listing overflow-auto px-6 sm:px-8 lg:px-10">
        <div className="space-y-12">
          <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 py-12 md:grid-cols-3">
            <div>
              <h2 className="text-base font-semibold leading-7 text-gray-900">
                Profile
              </h2>
              <p className="mt-1 text-sm leading-6 text-gray-600">
                This information will be displayed publicly so be careful what
                you share.
              </p>
            </div>

            <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
              

              <div className="sm:col-span-4">
                <label
                  htmlFor="first-name"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Company Name
                </label>
                <div className="mt-2">
                  <input
                  value={companyName}
                  onChange={(e)=>{setCompanyName(e.target.value);}}
                    type="text"
                    name="first-name"
                    id="first-name"
                    autoComplete="given-name"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#49BCD2] sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
              <div className="sm:col-span-4">
                <label
                  htmlFor="first-name"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Website
                </label>
                <div className="mt-2">
                  <input
                  value={website}
                  disabled
                    type="text"
                    name="first-name"
                    id="first-name"
                    autoComplete="given-name"
                    className="block w-full disabled:bg-gray-200 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#49BCD2] sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
            <div>
              <h2 className="text-base font-semibold leading-7 text-gray-900">
                Personal Information
              </h2>
              <p className="mt-1 text-sm leading-6 text-gray-600">
                Use a permanent address where you can receive mail.
              </p>
            </div>

            <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
              <div className="sm:col-span-3">
                <label
                  htmlFor="first-name"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  First name
                </label>
                <div className="mt-2">
                  <input
                  value={fName}
                  onChange={(e)=>{setFName(e.target.value);}}
                    type="text"
                    name="first-name"
                    id="first-name"
                    autoComplete="given-name"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#49BCD2] sm:text-sm sm:leading-6"
                  />
                </div>
              </div>

              <div className="sm:col-span-3">
                <label
                  htmlFor="last-name"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Last name
                </label>
                <div className="mt-2">
                  <input
                  value={lName}
                  onChange={(e)=>{setLName(e.target.value);}}
                    type="text"
                    name="last-name"
                    id="last-name"
                    autoComplete="family-name"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#49BCD2] sm:text-sm sm:leading-6"
                  />
                </div>
              </div>

              <div className="sm:col-span-4">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Email address
                </label>
                <div className="mt-2">
                  <input
                  disabled
                  value={email}
                  onChange={(e)=>{setEmail(e.target.value);}}
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    className="block w-full disabled:bg-gray-200 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#49BCD2] sm:text-sm sm:leading-6"
                  />
                </div>
              </div>

              <div className="sm:col-span-2 sm:col-start-1">
                <label
                  htmlFor="city"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Mobile
                </label>
                <div className="mt-2">
                  <input
                  value={mobile}
                  onChange={(e)=>{setMobile(e.target.value);}}
                    type="number"
                    name="city"
                    id="city"
                    autoComplete="address-level2"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#49BCD2] sm:text-sm sm:leading-6"
                  />
                </div>
              </div>

              <div className="sm:col-span-2">
                <label
                  htmlFor="region"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  UserType
                </label>
                <div className="mt-2">
                  <input
                    value={fetchUser?.user_type === 3 ? "Admin" : "Child"}
                    disabled
                    type="text"
                    name="region"
                    id="region"
                    autoComplete="address-level1"
                    className="block w-full disabled:bg-gray-200 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#49BCD2] sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      </div>
    </>
  );
}
